import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

// VFX: Broadcast L-Shape Lower Third
// Category: lower-thirds · Tags: lower-third, broadcast, l-shape, news, professional
const BroadcastLThird: React.FC<{
  name?: string; title?: string; accentColor?: string; barColor?: string;
}> = ({ name = "João Silva", title = "CEO · Empresa X", accentColor = "#ef4444", barColor = "#0f172a" }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const barSp = spring({ frame, fps, config: { stiffness: 200, damping: 24 } });
  const textSp = spring({ frame: frame - 8, fps, config: { stiffness: 150, damping: 22 } });
  const barW = interpolate(barSp, [0, 1], [0, 1]);
  return (
    <AbsoluteFill style={{ justifyContent: "flex-end", padding: "0 0 200px 60px" }}>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "stretch" }}>
        <div style={{ width: 8, background: accentColor, transform: `scaleY(${barSp})`, transformOrigin: "bottom", borderRadius: 4 }} />
        <div style={{
          background: barColor, padding: "18px 32px",
          width: `${barW * 580}px`, overflow: "hidden", opacity: barSp,
          borderRadius: "0 6px 6px 0",
          boxShadow: "0 12px 32px rgba(0,0,0,0.4)"
        }}>
          <p style={{ margin: 0, fontSize: 42, fontWeight: 800, color: "#fff", whiteSpace: "nowrap", opacity: textSp }}>{name}</p>
          <p style={{ margin: "4px 0 0", fontSize: 24, fontWeight: 400, color: "rgba(255,255,255,0.75)", whiteSpace: "nowrap", opacity: textSp }}>{title}</p>
        </div>
      </div>
    </AbsoluteFill>
  );
};

export default function LowerBroadcastLShape600Ms() {
  return (
    <AbsoluteFill style={{ background: "linear-gradient(180deg, #1e293b 0%, #0a0e1a 100%)" }}>
      <BroadcastLThird />
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
